import { BONUS_SCORE } from '../constants/prizeTypes';
import { image } from '../../../../utils/data/baseUrl';

export default function getAchievementIcon(prize) {
  const { type } = prize ?? {};

  return { [BONUS_SCORE]: image('achievement/icons/coin.png') }[type] ?? image('achievement/icons/prize.png');
}
